export default function isMobile(breakpoint) {
    return window.innerWidth <= breakpoint;
}
